import React, { createContext, useState, useContext } from 'react';

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);
  const [hasFetched, setHasFetched] = useState(false); // Add global flag for initial fetch

  return (
    <NotificationContext.Provider value={{ notifications, setNotifications, hasFetched, setHasFetched }}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotifications = () => useContext(NotificationContext);
